import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Hassan Wageh </span>
            <br />
            A dedicated <span className="purple"> Full Stack Developer </span> with a strong foundation in both frontend interfaces and backend architectures.
            <br />
            I have successfully engineered and deployed complex web applications, including fully functional E-commerce platforms with isolated and secure APIs.
            <br />
            <br />
            Apart from writing clean code, some other activities that I am passionate about:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Architecting SaaS Products
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring Advanced System Design
            </li>
            <li className="about-activity">
              <ImPointRight /> Managing Server Deployments & Hosting
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build systems that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Hassan</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
